import { Button } from "@mui/joy";
import { debounce } from "lodash";
import useOpenNewMeditationRecord from "hooks/useOpenNewMeditationRecord";
import { AddIcon } from "static/image/common/IconAssets";
import useIsRecordSeparatedPage from "hooks/useIsRecordSeparatedPage";
import useIsInappWebview from "hooks/useIsInappWebview";
import { generateRecordKey } from "logic/logics";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import { useNavigate } from "react-router-dom";

export default function AddNewMeditationRecordButton({
  disabled,
}: {
  disabled: boolean;
}) {
  const userState = useRecoilValue(userAtom);
  const isRecordSeparatedPage = useIsRecordSeparatedPage();
  const isTaskContainerSmall = useIsInappWebview();
  const navigate = useNavigate();

  const openNewMeditationRecord = useOpenNewMeditationRecord();

  const debouncedOnClick = debounce(() => {
    if (isRecordSeparatedPage) {
      const meditationRecordKey = generateRecordKey(
        userState?.userId!!,
        "meditation"
      );
      navigate(`/meditation-record-detail?mrk=${meditationRecordKey}`);
    } else {
      openNewMeditationRecord();
    }
  }, 100);

  return (
    <Button
      fullWidth
      onClick={debouncedOnClick}
      size={isTaskContainerSmall && !isRecordSeparatedPage ? "sm" : "lg"}
      variant="Soft"
      sx={{
        minWidth: 0,
        paddingInline: 0,
        ...(isTaskContainerSmall &&
          !isRecordSeparatedPage && { width: "64px", "--Button-gap": 0 }),
        ...((!isTaskContainerSmall || isRecordSeparatedPage) && {
          "--Button-gap": "4px",
        }),
      }}
      disabled={disabled}
      startDecorator={<AddIcon size={16} />}
    >
      {(!isTaskContainerSmall || isRecordSeparatedPage) && "훈련하기"}
    </Button>
  );
}
